import React from 'react';

import styles from '../../contractDetails.module.scss';

interface MetadataRowProps {
  lastDataSync?: string;
  lastContractProcess?: string;
  contact?: string;
}

export function MetadataRow( {
  lastDataSync = 'Pending',
  lastContractProcess = 'N/A',
  contact = '-'
}: MetadataRowProps ) {
  return (
    <div className={ styles.metadataRow }>
      <div className={ styles.metadataItem }>
        <label>Last Data Sync</label>
        <span>{ lastDataSync }</span>
      </div>
      <div className={ styles.metadataItem }>
        <label>Last Contract Process</label>
        <span>{ lastContractProcess }</span>
      </div>
      <div className={ styles.metadataItem }>
        <label>Contact</label>
        <span>{ contact }</span>
      </div>
    </div>
  );
}
